import { render, staticRenderFns } from "./AdministrativePermitsFormModal.vue?vue&type=template&id=33aba523&scoped=true"
import script from "./AdministrativePermitsFormModal.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsFormModal.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsFormModal.vue?vue&type=style&index=0&id=33aba523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aba523",
  null
  
)

export default component.exports